import React, {useContext} from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "../ui/button";
import {postWithToken} from "../../api/apiBase";
import {UserContext} from "../../contexts/UserContext";
import {useAuthInfo} from "@propelauth/react";

interface ClaimCompanyBannerProps {
    companyName?: string;
}

export default function ClaimCompanyBanner({ companyName }: ClaimCompanyBannerProps) {
    const userContext = useContext(UserContext);
    const {accessToken} = useAuthInfo()

    const onClaim = () => {
        postWithToken('/company/claim_company', JSON.stringify({
            company_id: userContext?.company_id
        }), accessToken!).then((res) => {
                if(res.success){
                    window.location.reload()
                }
            }

        ).catch((e) => {})

    }
    return (
        <div className="mb-4 flex items-center justify-between rounded-md border border-amber-300 bg-amber-50 px-4 py-3">
            <div className="flex items-center gap-2">
                <AlertTriangle className="h-5 w-5 shrink-0 text-amber-500" />
                <span className="text-sm text-amber-800">
                    {companyName ? `"${companyName}"` : "This company"} was created on your behalf.
                    Claim it to manage settings and invite team members.
                </span>
            </div>
            <Button
                variant="outline"
                size="sm"
                className="ml-4 shrink-0 border-amber-400 text-amber-700 hover:bg-amber-100"
                onClick={onClaim}
            >
                Claim Company
            </Button>
        </div>
    );
}
